const TREE_LEVELS = [
  ["건물", "building_name"],
  ["층", "floor"],
  ["위치", "location"],
  ["설비", "facility_name"],
  ["부품", "part_name"],
];

export default function FileTreePath({ file, uploadId }) {
  if (!file || String(file.upload_id) !== String(uploadId)) return null;

  const path = TREE_LEVELS.map(([level, key]) => ({ level, name: String(file[key] ?? "").trim() }))
    .filter(({ name }) => name);

  return <div className="fileDetail__treePath" role="group" aria-label="현재 파일의 위치" tabIndex={0}>
    {path.length ? path.map(({ level, name }, index) => <span className="fileDetail__treePathItem" key={level}>
      {index > 0 && <span className="fileDetail__treePathSeparator" aria-hidden="true">/</span>}
      <span>{name}</span>
    </span>) : <span className="fileDetail__treePathEmpty">지정된 경로 없음</span>}
  </div>;
}
